<template>
  <div class="no-permission-page">
    <h1>{{ $t("noPermission.title") }}</h1>
    <p>{{ $t("noPermission.message") }}</p>
    <router-link to="/" class="no-permission-action">
      <ActionButton
        custom-class="cdlButton"
        :title="$t('noPermission.returnHome')"
      />
    </router-link>
  </div>
</template>

<script>
import ActionButton from "@/components/Primitives/Buttons/ActionButton.vue";

export default {
  name: "NoPermissionPage",
  components: {
    ActionButton,
  },
};
</script>

<style scoped>
.no-permission-page {
  text-align: center;
  margin-top: 50px;
}

.no-permission-action {
  display: block;
  width: 280px;
  max-width: 100%;
  margin: 30px auto 0;
}
</style>
